module.exports = __webpack_public_path__ + "static/media/eat-wisely.0c12caa0.jpg";